var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('app-header'),_c('app-hiraya-message'),_c('app-factory-message'),_c('app-awards'),_c('app-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }